// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Tracker from './utils/tracker'

Vue.prototype.$globalConfig = {
  apkUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.vipshop.hhcws',
  // apkUrl: 'http://app.vip.com/update/wdg_android/official/wdg_android_official_3.0.0.apk',
  appleUrl: 'https://apps.apple.com/cn/app/id1419100271'
}
Vue.config.productionTip = false

Vue.prototype.$tracker = Tracker

router.afterEach(() => {
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js